<template>
  <div class="fullScreen">
    <div id="login">
      <div class="loginWrap">
        <div class="logoTitle">
          <img class="logo"
               src="@/assets/images/footballAssociation.png"
               alt="">
          <img class="title"
               src="@/assets/images/title_picture.png"
               alt="">
        </div>
        <div class="loginBox">
          <div class="loginTitle">
            {{login_title}}
          </div>
        </div>
  
<!--        <div class="HTM_PRO">-->
<!--          <el-button type="primary" class="HTM_PRO_BUTTON" @click="showProDialog=true">港澳台学员职业级教练员培训班报名入口<span style="margin-left: 5px">>></span></el-button>-->
<!--        </div>-->
      </div>
    </div>
    <app-footer></app-footer>
    <el-dialog title="验证手机号及重置密码" custom-class="VerifyPhone" :visible.sync="isVerifyPhone" :close-on-click-modal="false" :show-close="false"
               width="450px">
      <div id="VerifyPhone">
        <!--<el-form :model="Iphone" label-width="100px">
          <el-form-item label="手机号">.
            <el-row>
              <el-col :span="15">
                <el-input v-model="Iphone.mobile_phone" disabled></el-input>
              </el-col>
              <el-col :span="2"></el-col>
              <el-col :span="7">
                <el-button type="primary" @click="sendCode">发送验证码</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>-->
        <el-form ref="form"
                 :model="form"
                 :rules="rules"
                 label-width="100px">
          <el-form-item label="手机号">
                <el-input v-model="form.mobile_phone" disabled></el-input>
              <el-tooltip  placement="right" effect="light">
                <div slot="content" class="no_code_method">
                  <p>解决办法</p>
                  <p>1: 如果您正在培训期间需要更换手机号，请通过培训班协调员联系培训组织协会修改；</p>
                  <p>2: 如果您已经更换了手机号码，请您使用本人在系统个人资料中填写的电子邮箱发送修改前后的手机号和个人身份证信息到songmh@yioks.com，身份确认后将会在三个工作日内更改您系统默认手机号，默认手机号修改完成后您再使用“忘记密码”功能重新设置系统密码；</p>
                </div>
                <div class="get_none_code">手机号码已更换？</div>
              </el-tooltip>

<!--              <el-popover-->
<!--                      placement="right"-->
<!--                      title="解决办法"-->
<!--                      width="400"-->
<!--                      trigger="hover"-->
<!--                      popper-class="method_no_code"-->
<!--              >-->
<!--                <p>1: 通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；</p>-->
<!--                <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>-->
<!--                <p>3: 请确认手机号码是否正确，手机是否欠费；</p>-->
<!--                <p>4: 关机后重新启动手机，重新加载手机和基站的通信链路；</p>-->
<!--                <p>5: 联系电话客服；</p>-->
<!--                <div class="get_none_code" slot="reference" >收不到验证码？</div>-->
<!--              </el-popover>-->
          </el-form-item>
          <el-form-item label="验证码"
                        prop="code">
            <el-row style="position: relative">
              <el-col :span="14">
                <el-input v-model.trim="form.code"
                          placeholder="请输入验证码"></el-input>
              </el-col>
              <el-col :span="1">&nbsp;</el-col>
              <el-col :span="9">
                <el-row type="flex"
                        justify="end">
                  <el-button v-if="codeBtnFlag"
                             type="primary"
                             @click="sendCode">发送验证码
                  </el-button>
                  <el-button v-else
                             disabled
                             type="info">{{sec}}秒后重发
                  </el-button>
                </el-row>
              </el-col>

              <el-tooltip  placement="right" effect="light">
                <div slot="content" class="no_code_method">
                  <p>解决办法</p>
                  <p>1: 通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；</p>
                  <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>
                  <p>3: 请确认手机号码是否正确，手机是否欠费；</p>
                  <p>4: 关机后重新启动手机，重新加载手机和基站的通信链路；</p>
                  <p>5: 如果您正在培训期间需要更换手机号，请通过培训班协调员联系培训组织协会修改；</p>
                  <p>6: 如果您正在培训期间发现初始手机号显示错误需要更换手机号，请通过培训班协调员联系培训组织协会修改；</p>
                  <p>7: 联系电话客服；</p>
                </div>
                <div class="get_none_code"  >收不到验证码？</div>
              </el-tooltip>
            </el-row>
          </el-form-item>
          <el-form-item label="密码"
                        prop="pwd">
            <el-input type="password"
                      v-model.trim="form.pwd"
                      placeholder="请输入8—16位字母和数字组合"></el-input>
          </el-form-item>
          <el-form-item label="确认密码"
                        prop="affirm_pwd">
            <el-input type="password"
                      v-model.trim="form.affirm_pwd"
                      placeholder="请确认新密码"></el-input>
          </el-form-item>
          <div v-show="errPhoneFlag"
               class="tips">{{ errPhoneMsg }}
          </div>
          <div class="btns">
            <div class="btn yes"
                 @click="onSubmitPwd">确定
            </div>
            <div class="btn no"
                 @click="onCancel">取消
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog class="yi-dialog-root chose_user_type" :visible.sync="isVerifyUserType" :close-on-click-modal="false" :show-close="false" width="450px" @open='choseDiaOpen'>
      <div class="slot-dialog-header" slot="title">
        <span class="title">请选择您的使用场景</span>
        <span class="btn" @click="chooseUserType">确定</span>
      </div>
      <div class="radioUserType dialog-content">
        <div class="user_radio_list">
          <div class="radio_wrap" v-for="(type, i) in memberTypeList" :key="type.role">
            <div :class="['radio', activeTypeIdx===i?'checked':'', isStudentRole(type.role) ? '' : type.status ? '': 'disabled']" @click="choseType(i,type)" >
              <img class="img" :src="type.role | verifyRoleImg" alt="">
              <span class="type">{{type.name}} <span style="color:red" v-if="!isStudentRole(type.role)">{{type.status ? '' : "(已关闭)"}}</span></span>
              <!--<span class="type"></span>-->
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsLoginFlag"
                :tips="tipsLoginMsg"
                @hideTips="hideLoginTipsDialog"></yioks-tips>
    <yioks-iKnow :showTips="tipsClassFlag" :tips="tipsClassMsg" @hideTips="iKnowOK"></yioks-iKnow>
  </div>
</template>

<script>
  import "vue-awesome/icons/user";
  import "vue-awesome/icons/lock";
  import "vue-awesome/icons/check";

  import registrationImg from '@/assets/images/login/login_registration.png';
  import teacherImg from '@/assets/images/login/login_teacher.png';
  import studentImg from '@/assets/images/login/login_student.png';

  import {
    getLoginSalt,
    getLogin,
    getResetSendCode,
    getResetSalt,
    getResetSendVerify,
    authorizationLoginCheck,
    authorizationLogin,
  } from "@/api/common/login";
  import {storageData} from "@/assets/js/storage";
  import {hex_hmac_sha256} from "@/assets/js/sha";
  import {routerJump} from "@/assets/js/yioksRouter";
  import Tips from "@/components/Tips/Dialog";
  import { mapMutations } from "vuex";
  import {HMT_user_apply} from "@/api/ab_signup/api";
  import { roleHash } from "@/assets/js/five";
  import fiveMixins from '@/minix/fiveMixins';
  import commonFun from "@/assets/js/yioks";
  import {signOut} from "@/api/common/api";
  const { time } = commonFun;
  import store from '@/store';
  export default {
    name: "authorizationLogin",
    mixins: [fiveMixins],
//    beforeRouteEnter: (to, from, next) => {
//      const token = storageData.getToken();
//      yioks_vm.$options.token=token;
//
//      if (token) {
//        const path = routerJump();
//        next({path:path,query: to.query});
//      } else {
//        next();
//      }
//    },
    data() {
      const  validaPhone= (rule, val, callback) => {
        if (!this.$yioks.phone(val)) {
          callback(new Error("请输入有效的手机号码"));
        } else {
            callback();
        }
      };
      const  validaIDNum= (rule, val, callback) => {
        if (!val) {
          callback(new Error('请输入港澳台证件号码'))
        } else {
          if (!this.ID_Num_Flag) {
            callback()
          } else {
            this.ID_Num_Flag = false;
            callback(new Error(this.ID_Num_Msg))
          }
        }
      }
      const isWin = /windows|win32/i.test(navigator.userAgent);
      const isMobile = /iPhone|iPod|Android|ios|iPad/i.test(navigator.userAgent);
      return {
        isWin,
        isMobile,
        validaPhone,// 港澳台职业级手机号验证
        validaIDNum, // 港澳台职业级 证件号验证
        showSuccess:false, //港澳台是否成功提交
        ID_Num_Flag:false,
        ID_Num_Msg:'',
        checked:false,
        H_M_T_PRO_OBJ:{
        apply_id:'',
        name:'',
        certificate_url:'', //港澳台需要提交的东西
        resident_type:'',
        resident_number:'',
        mobile_phone:''
        },
        hmt_typeList:[{val:'HTM',label:'港澳台居住证'},{val:'HMTHOME',label:'港澳台通行证（回乡证）'}],
        showProDialog:false,
        tipsLoginFlag: false,
        tipsLoginMsg: "此帐号已经在另一个地方登录，继续登录被迫使对方下线，是否继续登录？",
        repeatSubmit: false,
        repeatSubmitElse: false,
        isVerifyPhone: false,
        isVerifyUserType: false,
        isCheck: false,
        userFocus: false,
        passFocus: false,
        userErr: false,
        passErr: false,
        errMsg: "",
        errFlag: false,
        user_name: "",
        password: "",
        errPhoneMsg: "",
        errPhoneFlag: false,
        code_flag: false, // 用于标记后台返回错误提示，进行重校验
        code_msg: "", // 存储后台错误提示
        tipsClassFlag: false,
        tipsClassMsg: "您参加的培训班正在审批流程中，请在培训班开始前48小时激活使用。",
        form: {
          mobile_phone: "",
          pwd: "",
          affirm_pwd: "",
          code: ""
        },
        loginPwb: "",
        loginUserType: "",
        /*Iphone: {
          mobile_phone: ""
        },*/
        rules: {
          code: [
            {
              required: true,
              validator: (rule, val, callback) => {
                if (this.$yioks.code(val)) {
                  if (!this.code_flag) {
                    callback();
                  } else {
                    this.code_flag = false;
                    callback(new Error(this.code_msg));
                  }
                } else {
                  callback(new Error("请输入有效的验证码"));
                }
              },
              trigger: "blur"
            }
          ],
          pwd: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!this.$yioks.pwd(value)) {
                  callback(new Error("8—16位字母（区分大小写）和数字组合"));
                } else {
                  if (this.form.affirm_pwd !== "") {
                    this.$refs.form.validateField("affirm_pwd");
                  }
                  callback();
                }
              },
              trigger: "blur"
            }
          ],
          affirm_pwd: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!this.$yioks.pwd(value)) {
                  callback(new Error("8—16位字母（区分大小写）和数字组合"));
                } else if (value !== this.form.pwd) {
                  callback(new Error("两次输入密码不一致!"));
                } else {
                  callback();
                }
              },
              trigger: "blur"
            }
          ]
        },
        tempToken: "",
        tempUserType: "",
        codeBtnFlag: true,
        sec: 60,
        memberTypeList: [],
        activeTypeIdx: 0,
        accountNo:"",
        access_token:"",
        login_title:"平台登录中……",
      };
    },
    components: {
      "v-icon": () => import("vue-awesome/components/Icon"),
      "app-footer": () => import("@/components/LayOut/Common/Footer"),
      "yioks-tips": Tips,
      "image-up": () => import("@/components/UpImage/UpImage"),
      "yioks-iKnow": () => import('@/components/Tips/iKnow'),

    },
    // 首页变灰，剩下页面不变
    mounted() {
      // document.getElementsByTagName('html')[0].style['-webkit-filter'] = 'grayscale(100%)';
    },

    destroyed() {
      // document.getElementsByTagName('html')[0].style['-webkit-filter'] = 'none';
    },
    filters: {
      verifyRoleImg(role){
        return roleHash[role];
      }
    },
    created() {
      const token = storageData.getToken();
      if(token){ // 如果有token 先退出在登陆吧
        this.hideLoginOut();
      }
      if(!this.$route.query.code){
        this.$router.push({
          path: '/login',
        })
      }
      // 根据code 登录
      this.authorLoginCheck();
    },
    methods: {
      hideLoginOut(bool, flag) {
        this.$store.commit('clearHeartBeat'); // 清除心跳
        const token = storageData.getToken();
        const userType = storageData.getUserType();
        yioks_vm.$options.token=''
        // 退出登录接口
        signOut({}, token, userType)
        .catch((err) => {
          console.error(err);
        });
        this.$store.commit('updateIsLogin',false)
        storageData.clearUserInfo();
        storageData.clearToken();
        storageData.clearUserType();
      },
      authorLoginCheck() {
        // this.user_name = this.user_name.toUpperCase();
        authorizationLoginCheck({code:this.$route.query.code})
        .then(res => {
          // console.log(res);
          if (Number(res.data.status) === 0) {
            const { member_type ,accountNo,access_token} = res.data.result;
            this.accountNo=accountNo;
            this.access_token=access_token;
            // 如果存在角色直接进入
            if (this.loginUserType){
              this.authorLogin(0);
              return;
            }
            // 如果没有返回角色
            if (!member_type){
              this.authorLogin(0);
              return;
            }else {
              // 返回多个角色，进行弹框
              this.memberTypeList = member_type;
              this.isVerifyUserType = true;
              this.repeatSubmit = false;
              //this.chooseUserType("registration");
            }
          } else {
            this.login_title = res.data.msg
            console.info(res)
          }
        })
        .catch(err => {
          this.repeatSubmit = false;
          console.error(err);
        });
      },
      
      authorLogin(force){
        let obj = {
          accountNo: this.accountNo,
          access_token: this.access_token,
        };
        force && Object.assign(obj, {force: force});
        this.loginUserType && Object.assign(obj, {userType: this.loginUserType});
        
        authorizationLogin(obj)
        .then(res => {
          if (res.data.status === 0) {
            const {user_info, phone_status} = res.data.result;
            const token = user_info.token;
            const user_type = user_info.member_type;
            yioks_vm.$options.token=token
            /* 更新状态管理用户信息 */
            this.updateUserInfo(user_info);
      
            /**
             * 判断是否需要进行手机验证操作
             */
            // console.log("phone_status:  " + phone_status);
            if (phone_status == 1) {
              this.$set(this.form, "mobile_phone", user_info.mobile_phone);
              this.tempToken = token;
              this.tempUserType = user_type;
              this.isVerifyPhone = true;
              return;
            }
            this.isCheck ? storageData.setLoginData(this.user_name, this.password) : storageData.clearLoginData();
            /* 保存token，调整路由 */
            this.routerLogin(token,user_type);
          } else if (res.data.status === 4) {
            this.tipsLoginMsg = res.data.msg.replace(/[,，]/g, "<br>");
            this.tipsLoginFlag = true;
            // return;
          }else if (res.data.status === 435) {
            const {className, endDate, startDate,class_the_quality} = res.data.result;
            let hours = 48;
            if(class_the_quality === 'eleven'){
              hours = 24;
            }
            this.tipsClassMsg = "您参加的“ "+className+ " ”正在审批流程中，培训时间为：" + time(startDate, false) + "至" + time(endDate, false)+"，请在培训班开始前"+hours+"小时内激活使用。";
            this.tipsClassFlag = true;
            // return;
          }else {
            this.errMsg = res.data.msg;
            this.errFlag = true;
            this.loginUserType=''
            // throw new Error(res.data.msg);
            this.login_title = res.data.msg
            console.info(res.data.msg)
          }
        })
        .catch(err => {
          this.repeatSubmit = false;
          console.error(err);
        });
      },
      
      closeProDialog(){
        if (this.showSuccess){
          this.checked=false;
          this.$set(this.H_M_T_PRO_OBJ,'name','');
          this.$set(this.H_M_T_PRO_OBJ,'resident_type','');
          this.$set(this.H_M_T_PRO_OBJ,'resident_number','');
          this.$set(this.H_M_T_PRO_OBJ,'mobile_phone','');
          this.$set(this.H_M_T_PRO_OBJ,'certificate_url','');
          this.showSuccess=false;
          this.showProDialog=false;
        } else{
          this.$refs['mainForm'].resetFields();
          this.checked=false;
          this.showProDialog=false;
        }
      },
      ...mapMutations(["setHeartBeat", "clearHeartBeat", "updateUserInfo"]),
      
      getStorage() {
        const storage = storageData.getLoginData();
        if (storage.flag) {
          this.user_name = storage.u;
          this.password = storage.p;
          this.isCheck = true;
        }
      },
      userInputFocus() {
        this.userFocus = true;
        this.userErr = false;
        this.errFlag = false;
      },
      userInputBlur() {
        this.userFocus = false;
      },
      passInputFocus() {
        this.passFocus = true;
        this.passErr = false;
        this.errFlag = false;
      },
      passInputBlur() {
        this.passFocus = false;
      },
      check() {
        if (this.repeatSubmit) return;
        this.repeatSubmit = true;
        if (this.user_name != "" && this.password != "") {
          /*const token = storageData.getToken();
          if(token) {
            this.$message({
              message: '该帐号已登录，请先退出当前帐号！',
              type: 'warning'
            });
            return;
          }*/
          this.getSalt();
          return;
        }
        if (this.user_name == "") {
          this.userErr = true;
        }
        if (this.password == "") {
          this.passErr = true;
        }
        this.repeatSubmit = false;
      },
      choseDiaOpen() {
        for(let i = 0; i < this.memberTypeList.length; i++){
          if (this.memberTypeList[i].status) {
            this.activeTypeIdx = i
            break
          }
        }
        // this.activeTypeIdx = 0;
        this.loginUserType = ''
      },
      choseType(i,item) {
        if(this.isStudentRole(item.role)) {
          this.activeTypeIdx = i
        } else {
          if (!item.status) return
          this.activeTypeIdx = i;
        }
      },
      chooseUserType(){
        this.loginUserType = this.memberTypeList[this.activeTypeIdx].role;
        this.isVerifyUserType = false;
        this.authorLogin(0);
      },
      iKnowOK(){
        this.tipsClassFlag=false
        // 跳到本平台的登录页面
        this.$router.push({
          path: '/login',
        })
      },
      hideLoginTipsDialog(bool, sure){
        this.tipsLoginFlag = bool;
        if (sure) {
          // 点击确定继续登录
          this.authorLogin(1);
          // return;
        }else{
          //如果点击取消，把loginUserType去掉
          this.loginUserType=''
          // 跳到本平台的登录页面
          this.$router.push({
            path: '/login',
          })
        }
      },
      countdown() {
        this.codeBtnFlag = false;
        const timer = setInterval(() => {
          this.sec = this.sec - 1;
          if (this.sec == 0) {
            this.sec = 60;
            this.codeBtnFlag = true;
            clearInterval(timer);
          }
        }, 1000);
      },
      sendCode() {
        getResetSendCode({}, this.tempToken, this.tempUserType)
          .then(({data}) => {
            // console.log(data);
            const status = Number(data.status);
            if (status === 0) {
              this.$message.success("验证码发送成功~");
              this.errPhoneFlag = false;
              /* 倒计时 */
              this.countdown();
            } else if (
              status === 419 ||
              status === 420 ||
              status === 421
            ) {
              this.$message.error(data.msg);
              this.errPhoneFlag = false;
            } else {
              this.errPhoneMsg = data.msg;
              this.errPhoneFlag = true;
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      onSubmitPwd() {
        if (this.repeatSubmitElse) return;
        this.repeatSubmitElse = true;
        this.$refs.form.validate(valid => {
          if (valid) {
            getResetSalt({}, this.tempToken, this.tempUserType)
              .then(res => {
                // console.log(res);
                if (Number(res.data.status) === 0) {
                  this.errPhoneFlag = false;
                  const {salt} = res.data.result;
                  const pwd = hex_hmac_sha256(salt, this.form.pwd).toUpperCase();
                  const affirm_pwd = hex_hmac_sha256(
                    salt,
                    this.form.affirm_pwd
                  ).toUpperCase();
                  this.resetSendVerify(pwd, affirm_pwd);
                  return;
                }
                throw new Error(res);
              })
              .catch(err => {
                this.repeatSubmitElse = false;
                console.error(err);
              });
          } else {
            this.repeatSubmitElse = false;
            return false;
          }
        });
      },
      resetSendVerify(pwd, affirm_pwd) {
        getResetSendVerify({
          code: this.form.code,
          pwd: pwd,
          affirm_pwd: affirm_pwd
        }, this.tempToken, this.tempUserType)
          .then(res => {
            // console.log(res);
            this.errPhoneFlag = false;
            if (Number(res.data.status) === 0) {
              this.isCheck ? storageData.setLoginData(this.user_name, this.form.pwd) : storageData.clearLoginData();
              /* 保存token，调整路由 */
              this.routerLogin(this.tempToken, this.tempUserType);
              return;
            }
            if (Number(res.data.status) === 109) {
              this.code_msg = res.data.msg;
              this.code_flag = true;
              this.$refs["form"].validateField("code");
            } else {
              this.errPhoneMsg = res.data.msg;
              this.errPhoneFlag = true;
            }
            this.repeatSubmitElse = false;
          })
          .catch(err => {
            this.repeatSubmitElse = false;
            console.error(err);
          });
      },
      onCancel() {
        this.isVerifyPhone = false;
        // 跳到本平台的登录页面
        this.$router.push({
          path: '/login',
        })
      },
      routerLogin(token, userType) {
        store.commit('setHeartBeat')
        storageData.setToken(token);
        storageData.setUserType(userType);
        const path = routerJump();
        this.$router.replace({
          path,
          query: {}
        });
//        window.location.reload(true); // todo 目前不能刷新 一刷新就会重复调用，然后重新登录 然后code失效
      },
    }
  };
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/linDialog';

  .fullScreen {
    width: 100%;
    height: 100%;

    #VerifyPhone {
      .tips {
        position: absolute;
        right: 22px;
        bottom: 66px;
        color: $color_err;
        font-size: $font_size_base;
      }
      .get_none_code{
        position absolute
        bottom -30px
        cursor pointer
        right 0
        color #606266
      }
      .btns {
        display: flex;
        margin-top: 40px;

        .btn {
          padding: 5px 20px;
          margin: 0 20px;
          font-size: $font_size_medium;
          color: $color_white;
          border-radius: 2px;
          cursor: pointer;
        }

        .yes {
          margin-left: 110px;
          background-color: $color_suc;
          box-shadow: 0px 2px 10px $color_suc;
        }

        .no {
          background-color: $color_err;
          box-shadow: 0px 2px 10px $color_err;
        }
      }
    }

    $space = 50px
    .chose_user_type {
      .slot-dialog-header {
        justify-content space-between
      }
      .user_radio_list {
        display block
        margin-right -($space)
        margin-left -($space)
        margin-bottom -20px
        .radio_wrap {
          display inline-block
          padding-right $space
          padding-left $space
          width 50%
          margin-bottom 20px
          .radio {
            display flex
            align-items center
            justify-content center
            flex-direction column
            height 160px
            padding 10px 0
            cursor pointer
            user-select none
            &.disabled{
              cursor not-allowed
            }
            .img {
              display block
              width 45px
              margin 0 auto 10px
              border: 1px solid;
              border-radius: 20%;
            }
            .type {
              display block
              text-align center
              font-size $font_size_medium
              margin-bottom 5px
            }
            &::after {
              content: ''
              display block
              margin 0 auto
              box-sizing: content-box;
              border: 2px solid $color_suc;
              border-left: 0;
              border-top: 0;
              height: 15px;
              transform: rotate(45deg) scaleY(0);
              width: 6px;
              transition: transform .15s ease-in .05s;
              transform-origin: center;
            }
            &.checked {
              border 1px solid $color_suc
              &::after {
                transform: rotate(45deg) scaleY(1);
              }
            }
          }
        }
      }
      .btn {
        display inline-block
        line-height 1
        white-space nowrap
        cursor pointer
        text-align center
        box-sizing border-box
        outline none
        border none
        border-radius: 5px
        color $color_white
        padding: 8px 15px
        font-size: $font_size_medium
        background-color $color_suc
      }
    }
  }

  #login {
    height: calc(100% - 60px);
    display: flex;
    justify-content: center;
    user-select: none;

    .loginWrap {
      width: 1024px;
      padding: 95px 0 0;
      display: flex;
      flex-direction: column;

      .logoTitle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0 100px 0;

        .logo {
          width: 120px;
          height: 120px;
          margin: 0 15px 0 0;
        }
      }

      .loginBox {
        align-self: center;
        width: 70%;
        height: 160px;
        padding: 20px;
        background-color: $block_bg_color_base;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
        position: relative;
        .loginTitle{
          color: white;
          font-size: 20px;
          text-align: center;
          height: 120px;
        }
        .ab_enter {
          position absolute
          right 0
          top 0
          transform translateY(-100%)
          border-radius 5px 5px 0 0
          padding 10px 20px
          line-height 1.2
          font-size: $font_size_15;
          color: $color_white;
          background-color: $color_suc;
          cursor: pointer;
        }
        .bgBox {
          position: absolute;
          left: -57px;
          width: 150px;
          top: -80px;
          z-index: 100;
        }
        .warnBox{
          position absolute;
          right 75px
          top 84px
          cursor pointer
        }
        .username, .password {
          margin: 0 0 40px;
          display: flex;
          background-color: $color_white;
          border: 2px solid;

          .icon {
            width: 36px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ceced2;
            border-right: 1px solid #ceced2;
          }

          .iconFocus {
            color: $color_suc;
          }

          input {
            padding: 0 10px;
            flex: 1 1 auto;
            color: #3e3e3e;
            font-size: $font_size_base;
            line-height: 1.4;
            outline: none;
          }
        }

        .password {
          position: relative;

          .tips {
            position: absolute;
            right: 0;
            top: 38px;
            color: $color_err;
            font-size: $font_size_base;
          }
        }

        .borderFocus {
          border: 2px solid $color_suc;
          box-shadow: 0px 0px 5px 1px $color_suc;
        }

        .errBorder {
          border: 2px solid $color_err;
        }

        .loginBtn {
          height: 40px;
          margin: 0 0 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: $font_size_medium;
          color: $color_white;
          background-color: $color_suc;
          cursor: pointer;
        }

        .operate {
          margin: 0 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: $font_size_medium;
          .savePass {
            display: flex;
            align-items: center;
            cursor: pointer;
            color: $color_white;
            .check {
              width: 20px;
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: $color_suc;
              background: $color_white;
              border: 1px solid $color_suc;
              border-radius: 3px;
            }

            span {
              margin: 0 0 0 10px;
            }
          }

          .forgetPass {
            color: #ceced2;
            &:hover {
              color: $color_suc;
            }
          }
        }
        .chrome {
          font-size: $font_size_base;
          text-align: right;
          color: #ceced2;
        }
        .intro{
          color #ceced2
          margin-bottom 10px
        }
      }
      .HTM_PRO{
        align-self flex-end
        margin 20px 44px 0 0
        .HTM_PRO_BUTTON{
          font-size 18px
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    #login {
      .loginWrap {
        .loginBox{
          margin: 0 100px 0 0;
        }
        .HTM_PRO{
          margin: 20px 144px 0 0;
          }
      }

    }
  }
</style>

<style  lang="stylus" >
  @import '~@/assets/css/variable';
  .hmt_form_wrap
    height: 500px
    .HMT_FORM
      padding: 0 20px;
    .post_btns
      display flex
      margin-top 20px
      justify-content center
      .post
          margin-right 20px
  .no_code_method
    width 400px
    p
      font-size 14px
      color #606266
      margin-bottom  7px
      &:first-child
        border-bottom 1px solid #606266
        font-size 15px
  .hmt_form_wrap_success
    height 300px
</style>
